// ONLY MODIFY THIS FILE BY RUNNING THE FOLLOWING COMMAND:
// php artisan react:enum

export const PaymentStatus = {
  Pending: {
    Name: 'Pending',
    Value: 'pending',
  },
  Processing: {
    Name: 'Processing',
    Value: 'processing',
  },
  Paid: {
    Name: 'Paid',
    Value: 'paid',
  },
  Failed: {
    Name: 'Failed',
    Value: 'failed',
  },
} as const

export type PaymentStatusValue = (typeof PaymentStatus)[keyof typeof PaymentStatus]['Value']
